import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']

  copy(event) {
    this.inputTarget.value = event.params.value
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }
}
